import moment, { Moment } from 'moment';

const convertToServerDate = (value: Moment | string) => {
    return format(value, 'YYYY-MM-DD');
};

const format = (
    value: Moment | string,
    format = getDateFormatForLocales().appFormat,
) => {
    const mValue = moment.isMoment(value) ? value : moment(value);

    return mValue.format(format);
};

const formatDate = (value: Moment | string) => {
    return format(value);
};

const formatDateTime = (value: Moment | string) => {
    return format(value, 'DD/MM/YYYY h:mm a');
};

const formatToISO = (
    value?: Moment | string,
    keepOffset?: boolean | undefined,
) => {
    if (!value) {
        return value;
    }

    const mValue = moment.isMoment(value) ? value : moment(value);

    return mValue.toISOString(keepOffset);
};

export const DateHelper = {
    convertToServerDate,
    format,
    formatDate,
    formatDateTime,
    formatToISO,
};

export const getDateFormatForLocales = (
    isTimeEnabled = false,
): {
    formioFormat: string;
    appFormat: string;
} => {
    const defaultFormat = 'dd/MM/yyyy';
    const defaultFormat2 = 'DD/MM/yyyy';
    const browserLocale = window.navigator.language;
    const formatValue = defaultFormat;
    const timeFormat = 'HH:mm:ss';

    const formioFormat = isTimeEnabled
        ? `${defaultFormat} ${timeFormat}`
        : formatValue;

    const isUSALocale = browserLocale === 'en-US';

    if (isUSALocale) {
        return {
            formioFormat,
            appFormat: defaultFormat2,
        };
    }

    return {
        formioFormat,
        appFormat: defaultFormat2,
    };
};

export const getDateFormattedValue = (
    value: string,
    isTimeEnabled: boolean,
) => {
    const formattedDate = moment(value).format('DD/MM/yyyy');
    const formattedTime = moment(value).format('HH:mm:ss');
    const formattedDateDivider = formattedDate;
    const formattedValue = isTimeEnabled
        ? `${formattedDateDivider} ${formattedTime}`
        : formattedDateDivider;

    return (value ? formattedValue : value) || '';
};
